import { render, staticRenderFns } from "./psp-select-modal.vue?vue&type=template&id=0ed45033"
import script from "./psp-select-modal.vue?vue&type=script&lang=js"
export * from "./psp-select-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports